import { createContext } from "react";
import { type SavedConfiguration } from "~/features/configurator/Linear/models";

export interface SavedConfigurationItem extends SavedConfiguration {
  isBeingDeleted?: boolean;
  isBeingUpdated?: boolean;
}

export interface SavedConfigContextProps {
  updateItem: (code: string, newName: string, newComment: string) => void;
  deleteItem: (code: string) => void;
  selectItem: (code: string, newValue: boolean) => void;
  toggleComment: (code: string, newValue: boolean) => void;
  shareItemsViaSalesPartnerFinder: (item: SavedConfiguration[]) => void;
}

export const SavedConfigContext = createContext<SavedConfigContextProps>({
  updateItem: () => {},
  deleteItem: () => {},
  selectItem: () => {},
  toggleComment: () => {},
  shareItemsViaSalesPartnerFinder: () => {},
});
